function saveToLocalStorage(key: string, value: any) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error('Ошибка записи в localStorage:', error);
    }
}

function getFromLocalStorage(key: string) {
    try {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    } catch (error) {
        console.error('Ошибка чтения из localStorage:', error);
        return null;
    }
}

export {
    saveToLocalStorage,
    getFromLocalStorage,
}